<span class="detour ms-2">
  <img src="/img/detour.svg" title="{{ 'Spoj jede po lince s výlukovým jízdním řádem.' | translate }}" alt="Výlukový JŘ" />
</span>

